import { BUCKET_STYLES } from "./constants";
import { CaretRight, Clock, Buildings } from "@phosphor-icons/react";

export const CountryCard = ({ country, bucketName, onSelect, index }) => {
  const style = BUCKET_STYLES[country.bucket];
  const mandatory = country.evidence_requirements.filter((r) => r.level === "Mandatory").length;
  return (
    <button
      data-testid={`country-card-${country.id}`}
      onClick={() => onSelect(country)}
      className="country-card stagger-in text-left bg-white border border-slate-200 p-6 flex flex-col gap-4 w-full"
      style={{ animationDelay: `${index * 50}ms` }}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <span className="text-2xl">{country.flag}</span>
          <div>
            <p className="font-heading font-bold text-lg tracking-tight leading-none">{country.name}</p>
            <p className="font-mono-data text-[10px] text-slate-400 mt-1">{country.code}</p>
          </div>
        </div>
        <span className={`text-[10px] uppercase tracking-widest font-semibold px-2 py-1 ${style.badge}`}>{bucketName}</span>
      </div>
      <div className="space-y-2 text-sm">
        <p className="text-slate-600 line-clamp-2"><span className="font-semibold text-slate-900">HTA:</span> {country.hta_body.split("(")[0].trim()}</p>
        <p className="text-slate-600 line-clamp-2"><span className="font-semibold text-slate-900">Pathway:</span> {country.reimbursement_pathway.split("→")[0].trim()} →</p>
      </div>
      <div className="flex items-center gap-4 text-xs text-slate-500 border-t border-slate-100 pt-4">
        <span className="flex items-center gap-1.5"><Clock size={14} /> {country.review_timeline_months} mo review</span>
        <span className="flex items-center gap-1.5"><Buildings size={14} /> {mandatory} mandatory req.</span>
      </div>
      <div>
        <div className="flex justify-between items-center mb-1.5">
          <span className="overline-label text-slate-400">MAI Readiness</span>
          <span className="font-mono-data text-xs font-medium">{country.mai_readiness}</span>
        </div>
        <div className="h-1.5 bg-slate-100 w-full">
          <div className="h-full" style={{ width: `${country.mai_readiness}%`, background: style.color }} />
        </div>
      </div>
      <span className="flex items-center gap-1 text-xs font-semibold text-slate-900">
        Full profile <CaretRight size={12} weight="bold" />
      </span>
    </button>
  );
};
